"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldImpl = void 0;
const Contract = require("@tableau/api-external-contract-js");
const InternalContract = require("@tableau/api-internal-contract-js");
const InternalToExternalEnumMappings_1 = require("../EnumMappings/InternalToExternalEnumMappings");
class FieldImpl {
    constructor(_fieldInfo, _parentDataSource) {
        this._fieldInfo = _fieldInfo;
        this._parentDataSource = _parentDataSource;
    }
    get name() {
        return this._fieldInfo.name;
    }
    get id() {
        return this._fieldInfo.id;
    }
    get description() {
        return this._fieldInfo.description;
    }
    get dataType() {
        var _a;
        return (_a = this._fieldInfo.dataType) !== null && _a !== void 0 ? _a : Contract.DataType.Unknown;
    }
    get aggregation() {
        return InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.fieldAggregationType.convert(this._fieldInfo.aggregation);
    }
    get dataSource() {
        if (!this._parentDataSource)
            throw new Error(`Data source information is not available for this field. Please use getFieldAsync method to get field's data source information`);
        return this._parentDataSource;
    }
    get role() {
        return InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.fieldRoleType.convert(this._fieldInfo.role);
    }
    get columnType() {
        let definedValue = this._fieldInfo.columnType || InternalContract.ColumnType.Unknown;
        return InternalToExternalEnumMappings_1.InternalToExternalEnumMappings.columnType.convert(definedValue);
    }
    get isCalculatedField() {
        return this._fieldInfo.isCalculatedField;
    }
    get isCombinedField() {
        return this._fieldInfo.isCombinedField;
    }
    get isGenerated() {
        return this._fieldInfo.isGenerated;
    }
    get isGeospatial() {
        return this._fieldInfo.isGeospatial;
    }
    get isHidden() {
        return this._fieldInfo.isHidden;
    }
    get isPresentOnPublishedDatasource() {
        return this._fieldInfo.isPresentOnPublishedDatasource;
    }
    get semanticRole() {
        return this._fieldInfo.semanticRole;
    }
    get dataFormat() {
        return this._fieldInfo.dataFormat;
    }
}
exports.FieldImpl = FieldImpl;
//# sourceMappingURL=FieldImpl.js.map